import $ from 'jquery';

/**
 * Mobile navigation toggle
 * @param  {mixed} event
 */

AOS.init();

const toggleMenu = (event) => {
    event.preventDefault();
    $('.js-menu-toggle, .nav--header').toggleClass('open');
    $('.header').toggleClass('menu-open');
};

$('.js-menu-toggle').on('click', toggleMenu);

// When the user scrolls the page, execute myFunction
// window.onscroll = function() {myFunction()};

// Get the header
var header = document.getElementById("header");

// Get the offset position of the navbar
var sticky = header.offsetTop;

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function myFunction() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky");
  } else {
    header.classList.remove("sticky");
  }
}

if($('#hero-slide').length > 0) {
  var glide2 = new Glide('#hero-slide').mount({
    type: 'carousel',
    perView: 1
  })
  glide2.mount()
}


if($('#our-partners-slide').length > 0) {
  var glide1 = new Glide('#our-partners-slide', {
    perView: 3,
    breakpoints: {
      1300: {
        perView: 3
      },
      768: {
        perView: 2
      },
      600: {
        perView: 1
      }
    }  
  })

  glide1.mount()
}